























import Vue from 'vue';

import List from '@/models/soukai/List';
import Task from '@/models/soukai/Task';
import Workspace from '@/models/soukai/Workspace';

interface Data {
    name: string;
}

export default Vue.extend({
    data(): Data {
        return {
            name: '',
        };
    },
    methods: {
        async create() {
            if (!this.name)
                return;

            try {
                const activeList = this.$workspaces.active!.activeList;

                await activeList.createTask(this.consumeInput());
            } catch (error) {
                this.$ui.showError(error);
            }
        },
        consumeInput() {
            const name = this.name;

            this.name = '';

            return { name };
        },
    },
});
